import { useState } from 'react';

/** Replace files in /public: bth-logo.png (preferred) or bth-logo.svg */
export const BTH_LOGO_CANDIDATES = ['/bth-logo.png', '/bth-logo.svg'] as const;

type BthLogoProps = {
  className?: string;
  alt?: string;
};

export function BthLogo({ className = 'bth-logo', alt = 'Ban Teck Han' }: BthLogoProps) {
  const [logoIndex, setLogoIndex] = useState(0);
  const src = BTH_LOGO_CANDIDATES[logoIndex] ?? BTH_LOGO_CANDIDATES[1];

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      onError={() => {
        setLogoIndex((i) => (i + 1 < BTH_LOGO_CANDIDATES.length ? i + 1 : i));
      }}
    />
  );
}
